import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Architect_INTJ_personality_header from '../../images/personality_types_details/analysts_Architect_INTJ_personality_header.svg'
import analysts_Architect_INTJ_conclusion from '../../images/personality_types_details/analysts_Architect_INTJ_conclusion.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const intj_conclusion = () => {
    return (
        <Layout>
            <main className="q-td analyst architect">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/architect-intj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-careers" className="tab with-progress">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intjs-at-work" className="tab with-progress">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/architect-intj-conclusion" className="tab with-progress active">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header className="type-header analyst architect">
                    <svg className="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path className="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path className="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>
                    <img src={analysts_Architect_INTJ_personality_header} className="scene" alt='loading...' />
                    <div className="type-info">
                        <h1><span>Architect</span> Personality</h1>
                        <div className="code">INTJ-A / INTJ-T</div>
                        <a href="#" className="difference">(What’s the difference?)</a>
                    </div>
                </header>


                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/architect-intj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-parents">Parenthood</Link></li>
                                <li className=""><Link to="/personality-types/architect-intj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/architect-intjs-at-work">Workplace Habits</Link></li>
                                <li className="active"><Link to="/personality-types/architect-intj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>    Conclusion
</h1>


                        <blockquote><p>“No escape from patterns and systems, no exits. Nothing, and no one, resides outside a system; that’s the way it is.”</p> <footer>Lynne Tillman</footer></blockquote>

                        <p>Armed with powerful intellects and strategic minds, Architects (INTJs) can outmaneuver obstacles that seem unbeatable to most. But their strengths, when misunderstood, can turn into weaknesses – and keep them from reaching their full potential.</p>

                        <div class="scene"><img alt="Architect (INTJ) personality" src={analysts_Architect_INTJ_conclusion} /></div>

                        <p>Those misunderstandings end here. What you have read so far is just an introduction – we have a great deal more to tell you about the Architect personality type.</p>

                        <p>In reading through this personality profile, you probably hit a tipping point. You went from trademark Architect skepticism to “Huh…” to “Wait, <em>what</em>?” You may even be a little uncomfortable, because you’re not used to being understood, even by the people closest to you.</p>

                        <p>Chances are you’ve accepted this as part of who you are and maybe even grown proud of it. But embracing that disconnect isn’t a requirement for Architects. It’s a misused defense mechanism, leading you down a lonely, inefficient path. Gaining insight into yourself and others is so much more rewarding – and effective.</p>

                        <p>At 16Personalities, we’ve spent years studying Architects’ life stories, experiences, and patterns through hundreds of our surveys. Step by step, insight by insight, we’ve discovered the challenges that people with your personality face – and how those challenges can be overcome.</p>

                        <p>Our specialized, research-based offerings for Architects can show you how to use your strengths and avoid common pitfalls – while also staying true to who you are. Because that’s the point, isn’t it? To see how you can grow into your full potential, in ways that make sense for <em>you</em>.</p>

                        <p>If you’re ready to take the next step, Architect, read on.</p>

                        <div class="number">08</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/architect-intjs-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/' className='next-feature'>
                            Premium Profile
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default intj_conclusion
